import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserManagementCertificates = () => {
  const userDataService = useServices().manageUserDataService;
  return useQuery({
    queryKey: ['userManagementCertificates'],
    queryFn: userDataService.getAllCertificates,
    refetchOnWindowFocus: false,
  });
};

export const useGetShopCertifications = () => {
  const webshopService = useServices().webshopService;
  return useQuery({
    queryKey: ['shopCertificationTests'],
    queryFn: webshopService.getShopCertificationTests,
    refetchOnWindowFocus: false,
  });
};
